import React from 'react';
import Icon from '@/v2/components/atoms/Icon';

import './Message.scss';

const Message = (props) => (
    <Icon iconName="Message" {...props}>
        <svg viewBox="0 0 43 43" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g transform="translate(-807.000000, -850.000000)" stroke="#FFFFFF" strokeWidth="1.5">
                    <g transform="translate(807.000000, 850.000000)">
                        <path
                            // eslint-disable-next-line
                            d="M41.8838,21.3173 C41.8838,32.6753 32.6758,41.8833 21.3168,41.8833 C9.9578,41.8833 0.7498,32.6753 0.7498,21.3173 C0.7498,9.9583 9.9578,0.7503 21.3168,0.7503 C32.6758,0.7503 41.8838,9.9583 41.8838,21.3173 Z"
                            fillOpacity="0.4"
                            fill="#020A0D"
                        />
                        <path
                            // eslint-disable-next-line
                            d="M29.1055,14.9921 L13.5285,14.9921 C12.5515,14.9921 11.7605,15.7841 11.7605,16.7601 L11.7605,28.9011 C11.7605,29.2581 12.1915,29.4361 12.4435,29.1831 L14.8365,26.7911 L29.1055,26.7911 C30.0825,26.7911 30.8735,25.9991 30.8735,25.0221 L30.8735,16.7601 C30.8735,15.7841 30.0825,14.9921 29.1055,14.9921 Z"
                        />
                        <line x1="17.6543" y1="19.5546" x2="24.9793" y2="19.5546" id="Stroke-5" strokeLinecap="round" />
                        <line x1="17.6543" y1="22.6757" x2="21.8383" y2="22.6757" id="Stroke-7" strokeLinecap="round" />
                    </g>
                </g>
            </g>
        </svg>
    </Icon>
);

export default Message;
